/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_TabInputs */

const zh_preview_tab = /** @type {(inputs: Preview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const en_preview_tab = /** @type {(inputs: Preview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const es_preview_tab = /** @type {(inputs: Preview_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Preview_TabInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const preview_tab = /** @type {((inputs?: Preview_TabInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_TabInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_tab(inputs)
	if (locale === "en") return en_preview_tab(inputs)
	return es_preview_tab(inputs)
});